import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Graph from "@components/graphStatistics/Pie/Graphs";
import { customTooltips } from "@helpers/_functions";

export default function Index({ data }) {
  const { t } = useTranslation("pages.employés.statistics");
  const [graphData, setGraphData] = useState({});
  const chartRef = useRef(null);
  useEffect(() => {
      const parityData = {
        datasets: [
          {
            data: data?.map((item) => item.count) || [],
            backgroundColor: data?.map((item) => item.backgroundColor),
            hoverOffset: 4
          }
        ],
        labels: data.map(({name, count, percentValue }) => `${name} : ${count} (${percentValue}%)`) || [],
      };

      setGraphData(parityData);
  }, [data]);

  const customOptions = {
    tooltips: {
      enabled:false,
      custom: (tooltip)=>customTooltips(tooltip,chartRef,t),
    },
  };

  const translatedLegends = data
    ?.map(({ name, backgroundColor }) => ({
      name: t(name),
      backgroundColor
    }))
    .sort(({ name: nameA }, { name: nameB }) =>
      nameA?.toLowerCase() < nameB?.toLowerCase() ? -1 : 1
    );

  return (
    <Graph
        graphData={graphData}
        legends={translatedLegends}
        title={t("Préférences alimentaires")}
        spaceLegende="arh-space-y-2"
        customOptions={customOptions}
        chartRef={chartRef}
    />
  );
}
